export default "__VITE_ASSET__BS4u$8l1__"